import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useKatalog, urunYolu } from "../data/katalog";

/**
 * Son incelenen ürünler — ziyaretçinin kendi tarayıcısında tutulur (sunucuya gitmez).
 * Ürün detay sayfası açıldıkça listeye eklenir; ana sayfada ve ürün sayfasında gösterilir.
 */
const ANAHTAR = "akkuzey_son_incelenen";
const SINIR = 12;
const OLAY = "akkuzey-son-incelenen";

const oku = () => {
  try {
    const v = JSON.parse(localStorage.getItem(ANAHTAR) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const sonIncelenenEkle = (id) => {
  try {
    const liste = [id, ...oku().filter((x) => x !== id)].slice(0, SINIR);
    localStorage.setItem(ANAHTAR, JSON.stringify(liste));
    window.dispatchEvent(new Event(OLAY));
  } catch {
    /* gizli sekme ya da kapalı depolama: liste tutulmaz, sayfa yine çalışır */
  }
};

const sonIncelenenTemizle = () => {
  try {
    localStorage.removeItem(ANAHTAR);
    window.dispatchEvent(new Event(OLAY));
  } catch {
    /* yok say */
  }
};

export default function SonIncelenenler({ haric, cerceve = true }) {
  const { t } = useTranslation();
  const { urunler, hazir } = useKatalog();
  const [idler, setIdler] = useState(oku);

  useEffect(() => {
    const yenile = () => setIdler(oku());
    window.addEventListener(OLAY, yenile);
    window.addEventListener("storage", yenile);
    return () => {
      window.removeEventListener(OLAY, yenile);
      window.removeEventListener("storage", yenile);
    };
  }, []);

  const liste = useMemo(() => {
    const harita = new Map(urunler.map((u) => [u.id, u]));
    return idler.filter((id) => id !== haric).map((id) => harita.get(id)).filter(Boolean);
  }, [urunler, idler, haric]);

  if (!hazir || liste.length === 0) return null;

  const icerik = (
    <>
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <p className="eyebrow">{t("recent.eyebrow")}</p>
          <h2 className="mt-2 text-[20px] font-semibold tracking-tight text-ink sm:text-[22px]">
            {t("recent.title")}
          </h2>
        </div>
        <button
          onClick={sonIncelenenTemizle}
          className="text-[12.5px] text-muted transition-colors hover:text-accent"
        >
          {t("recent.clear")}
        </button>
      </div>

      <ul className="scrollbar-hide -mx-4 flex snap-x gap-3 overflow-x-auto px-4 pb-2 sm:mx-0 sm:px-0">
        {liste.map((u) => (
          <li key={u.id} className="w-40 shrink-0 snap-start sm:w-44">
            <Link
              to={urunYolu(u)}
              className="group flex h-full flex-col overflow-hidden rounded-xl border border-line bg-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_28px_-14px_rgba(0,0,0,0.25)]"
            >
              <span className="relative block aspect-square bg-white">
                <img
                  src={u.gorsel}
                  alt=""
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-contain p-3 transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="block border-t border-line/70 px-3 py-2.5 text-start">
                <span className="block text-[10.5px] font-semibold uppercase tracking-eyebrow text-muted">{u.marka}</span>
                <span className="mt-0.5 line-clamp-2 block text-[12.5px] font-medium leading-snug text-ink">{u.ad}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );

  return cerceve ? (
    <section className="border-t border-line">
      <div className="container-page py-12">{icerik}</div>
    </section>
  ) : (
    icerik
  );
}
